export default __webpack_public_path__ + "static/media/SAS0050.34I-34119_-18338_0.dae0eed0.jpg";